import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api.js'
import { useSessao } from '../sessao.jsx'
import { Campo, Erro, Aviso } from '../componentes/basicos.jsx'

export default function TrocarSenha() {
  const { usuario, setUsuario } = useSessao()
  const navegar = useNavigate()
  const [senhaAtual, setSenhaAtual] = useState('')
  const [senhaNova, setSenhaNova] = useState('')
  const [erro, setErro] = useState(null)
  const [enviando, setEnviando] = useState(false)

  const obrigatoria = usuario?.senha_precisa_troca

  async function enviar(evento) {
    evento.preventDefault()
    setEnviando(true)
    setErro(null)
    try {
      const { usuario: atualizado } = await api.put('/auth/senha', {
        senha_atual: senhaAtual,
        senha_nova: senhaNova,
      })
      setUsuario(atualizado)
      navegar('/', { replace: true })
    } catch (e) {
      setErro(e)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="app" style={{ paddingBottom: 0, justifyContent: 'center' }}>
      <main className="conteudo" style={{ maxWidth: 420 }}>
        <h1>Defina uma nova senha</h1>

        {obrigatoria && (
          <Aviso tipo="atencao">
            Esta conta ainda usa a senha inicial. Escolha uma senha sua para liberar o sistema.
          </Aviso>
        )}

        <form className="cartao pilha" onSubmit={enviar}>
          {!obrigatoria && (
            <Campo rotulo="Senha atual">
              <input type="password" value={senhaAtual} autoComplete="current-password" required
                     onChange={(e) => setSenhaAtual(e.target.value)} />
            </Campo>
          )}

          <Campo rotulo="Nova senha" dica="Mínimo de 8 caracteres.">
            <input type="password" value={senhaNova} autoComplete="new-password" required minLength={8}
                   onChange={(e) => setSenhaNova(e.target.value)} />
          </Campo>

          {!obrigatoria && (
            <p className="dica">
              Trocar a senha encerra a sessão nos outros aparelhos e revoga os tokens de acesso.
              Este aparelho continua conectado.
            </p>
          )}

          <Erro erro={erro} />

          <button type="submit" className="botao-principal botao-largo" disabled={enviando}>
            {enviando ? 'Salvando…' : 'Salvar senha'}
          </button>
        </form>
      </main>
    </div>
  )
}
